._ClientPrograms_kyl92_1 ._text_kyl92_1 {
  display: block;
  margin-bottom: 15px;
}